module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/thumbs/42-eae424ba1fd2ab615603862768fd67fe.webp";